import { format } from 'date-fns'

export const getUserProjectNameById = (user, projectId) => user?.projects?.filter((p) => p.id === projectId)[0]?.name

const thinBorderStyle = { style: 'thin' }

export const headerBorder = {
  top: thinBorderStyle,
  bottom: thinBorderStyle,
  left: thinBorderStyle,
  right: thinBorderStyle,
}

export const headerAlignment = { vertical: 'middle', horizontal: 'center' }

export const buildReportDate = (worksheet, start = 1) => {
  worksheet.mergeCells(`A${start}:A${start}`)
  const titleCell = worksheet.getCell(`A${start}`)
  titleCell.value = 'Дата формирования отчёта: '
  titleCell.alignment = { vertical: 'middle', horizontal: 'left' }
  titleCell.font = { size: 14, bold: false }

  worksheet.mergeCells(`B${start}:B${start}`)
  const dateCell = worksheet.getCell(`B${start}`)
  dateCell.value = format(new Date(), 'dd.MM.yyyy')
  dateCell.alignment = { vertical: 'middle', horizontal: 'center' }
  dateCell.font = { size: 14, bold: false }
}

export const buildProjectName = (worksheet, project, start = 2) => {
  worksheet.mergeCells(`A${start}:A${start}`)
  const titleCell = worksheet.getCell(`A${start}`)
  titleCell.value = 'Наименование проекта: '
  titleCell.alignment = { vertical: 'middle', horizontal: 'left' }
  titleCell.font = { size: 14, bold: false }

  worksheet.mergeCells(`B${start}:B${start}`)
  const projectCell = worksheet.getCell(`B${start}`)
  projectCell.value = project
  projectCell.alignment = { vertical: 'middle', horizontal: 'center' }
  projectCell.font = { size: 14, bold: false }
}

export const buildHeaderCell = (worksheet, index, title, start, width = 20) => {
  const column = worksheet.getColumn(`${index}`)
  column.width = width

  const cell = worksheet.getCell(`${index}${start + 1}`)
  cell.value = title
  cell.alignment = headerAlignment
  cell.font = { size: 14, bold: true }
  cell.border = headerBorder
}

export const buildSubHeaderCell = (worksheet, index, title, width = 20, start) => {
  const column = worksheet.getColumn(index)
  column.width = width
  const cell = worksheet.getRow(start + 1).getCell(index)
  cell.value = title
  cell.alignment = headerAlignment
  cell.font = { size: 14 }
  cell.border = headerBorder
}

export const buildMainHeaderCell = (worksheet, index, endIndex, title, start) => {
  // merge by start row, start column, end row, end column
  worksheet.mergeCells(start, index, start, endIndex)
  const cell = worksheet.getRow(start).getCell(index)
  cell.value = title
  cell.alignment = headerAlignment
  cell.font = { size: 14, bold: true }
  cell.border = headerBorder
}

export const buildMergedHeaderCell = (worksheet, index, title, start, width = 50) => {
  const column = worksheet.getColumn(`${index}`)
  column.width = width
  worksheet.mergeCells(`${index}${start}:${index}${start + 1}`)
  const cell = worksheet.getCell(`${index}${start + 1}`)
  cell.value = title
  cell.alignment = headerAlignment
  cell.font = { size: 14, bold: true }
  cell.border = headerBorder
}

export const buildCell = (worksheet, data, cellIndex, rowIndex = 0) => {
  const cell = worksheet.getRow(rowIndex).getCell(cellIndex)
  cell.value = data
  cell.alignment = { vertical: 'middle' }
}
